import { render, staticRenderFns } from "./detailWorkHours.vue?vue&type=template&id=22808453&scoped=true&"
import script from "./detailWorkHours.vue?vue&type=script&lang=js&"
export * from "./detailWorkHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22808453",
  null
  
)

export default component.exports